import { createAction } from 'redux-act';
import localforage from 'localforage';
import fetch from 'axios';
import { push } from 'connected-react-router';

/**
 * Create action
 */

import completeInitialisation from './initialise';

const request = createAction('LOGOUT_REQUEST');
const error = createAction('LOGOUT_ERROR');
const logout = createAction('USER_LOGOUT');

function logoutUser() {
    return function (dispatch) {
        // Dispatch the request action
        dispatch(request);

        return fetch
            .post(`/api/logout`)
            .then(async ({ result }) => {
                // Dispatch successa action
                dispatch(logout(result));

                // // Clear the persisted state
                // persistor.purge();
                // persistor.flush();

                // Logout the user
                await dispatch(logout());

                // Complete the initialisation
                dispatch(completeInitialisation());
                dispatch(push('/netwerk'));

                // Clear local storage
                localforage.clear();
            })
            .catch((err) => {
                dispatch(error(err));
                throw err;
            });
    };
}

export default logoutUser;
export { logout };
